import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
/** @jsx jsx */
/* eslint react/jsx-key: 0 */
import Highlight, { defaultProps } from 'prism-react-renderer';
import { jsx, Styled } from 'theme-ui';
import { usePrismTheme } from '~utils/theme';
import { jsx as ___EmotionJSX } from "@emotion/core";
export const Code = _ref => {
  let {
    children,
    className: outerClassName
  } = _ref;
  const [language] = outerClassName ? outerClassName.replace(/language-/, '').split(' ') : ['text'];
  const theme = usePrismTheme();
  return jsx(Highlight, _extends({}, defaultProps, {
    code: children.trim(),
    language: language,
    theme: theme
  }), _ref2 => {
    let {
      className,
      style,
      tokens,
      getLineProps,
      getTokenProps
    } = _ref2;
    return jsx(Styled.pre, {
      className: (outerClassName || '') + " " + className,
      style: _objectSpread(_objectSpread({}, style), {}, {
        overflowX: 'auto'
      }),
      "data-testid": "code"
    }, tokens.map((line, i) => jsx("div", getLineProps({
      line,
      key: i
    }), line.map((token, key) => jsx("span", _extends({}, getTokenProps({
      token,
      key
    }), {
      sx: {
        display: 'inline-block'
      }
    }))))));
  });
};
if (typeof Code !== 'undefined' && Code && Code === Object(Code) && Object.isExtensible(Code) && !Object.prototype.hasOwnProperty.call(Code, '__filemeta')) {
  Object.defineProperty(Code, '__filemeta', {
    configurable: true,
    value: {
      name: "Code",
      filename: "node_modules/gatsby-theme-docz/src/components/Code/index.js"
    }
  });
}